import LogoutIcon from '@mui/icons-material/Logout';
import Button from '@mui/material/Button';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

/**
 * Sidebar control for a visitor whose login was denied. Offers only a log out, since logging in
 * again would resume any Auth0 session into the same denial.
 */
export function UserControlLogOut() {
	const navigate = useNavigate();

	const handleLogOut = useCallback(() => {
		void navigate({ to: '/log-out' });
	}, [navigate]);

	return (
		<Button startIcon={<LogoutIcon />} onClick={handleLogOut}>
			<span>Log out</span>
		</Button>
	);
}
